import { defineComponent as h, computed as l, openBlock as s, createElementBlock as a, createElementVNode as t, toDisplayString as r, createCommentVNode as f, normalizeStyle as n, createStaticVNode as v } from "vue";
const p = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "acdadf62-0fdd-4c7c-9e22-cde11fdf6c62" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#acdadf62-0fdd-4c7c-9e22-cde11fdf6c62)" }, k = { key: 0 }, u = /* @__PURE__ */ v('<path fill="#0052b4" d="M256 0h256v512H0V256Z"></path><path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"></path><path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"></path><path fill="#ffda44" d="M411.8 300.5v11.2h-89v-11.2h-33.4V345h22.3v11.2H423V345h22.2v-44.5z"></path><path fill="#338af3" d="M289.4 133.6V256c0 59.6 77.9 78 77.9 78s78-18.4 78-78V133.6h-156z"></path><path fill="#eee" d="M367.3 224.9c-19.5 0-19.5 17.8-39 17.8s-19.4-17.8-39-17.8V256c19.6 0 19.6 17.8 39 17.8s19.5-17.8 39-17.8 19.5 17.8 39 17.8 19.4-17.8 39-17.8v-31.2c-19.6 0-19.6 17.8-39 17.8-19.5 0-19.5-17.8-39-17.8zm0-62.4c-19.5 0-19.5 17.8-39 17.8s-19.4-17.8-39-17.8v31.2c19.6 0 19.6 17.8 39 17.8s19.5-17.8 39-17.8 19.5 17.8 39 17.8 19.4-17.8 39-17.8v-31.2c-19.6 0-19.6 17.8-39 17.8-19.5 0-19.5-17.8-39-17.8z"></path>', 6), V = { fill: "none" }, g = ["r"], y = /* @__PURE__ */ h({
  __name: "fk",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(d) {
    const e = d, o = l(() => 512 + 2 * e.strokeWidth), c = l(() => -e.strokeWidth), i = l(() => 256 + e.strokeWidth / 2);
    return (x, w) => (s(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${o.value} ${o.value}`
    }, [
      _,
      t("g", m, [
        e.flagName ? (s(), a("title", k, r(e.flagName), 1)) : f("", !0),
        u
      ]),
      t("g", V, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: i.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, g)
      ])
    ], 8, p));
  }
});
export {
  y as default
};
//# sourceMappingURL=fk-0fa76bd1.js.map
